import { nullable } from '@ipfabric/utils/fp/nullable';
import { prop } from '@ipfabric/utils/fp/prop';
import {
  type GraphState,
  type TopologyGraphMetadata,
  isTopologyGraphMetadata,
} from 'components/Graph/GraphState';
import { flow } from 'fp-ts/lib/function';

export const selectTopologyMetadata: (
  s: GraphState,
) => TopologyGraphMetadata | null = flow(
  prop('graphMetadata'),
  nullable.fromPredicate(isTopologyGraphMetadata),
);
